/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown> }} Project_Locked_ByInputs */

const en_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This project is currently locked by ${i?.user}. You can save as a new copy instead.`)
};

const fr_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce projet est actuellement verrouillé par ${i?.user}. Vous pouvez enregistrer en tant que nouvelle copie.`)
};

const de_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Projekt ist derzeit von ${i?.user} gesperrt. Sie können es stattdessen als neue Kopie speichern.`)
};

const it_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo progetto è attualmente bloccato da ${i?.user}. Puoi salvarlo come nuova copia.`)
};

const ru_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`В настоящее время этот проект заблокирован пользователем ${i?.user}. Вместо этого вы можете сохранить его как новую копию.`)
};

const es_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este proyecto está bloqueado por ${i?.user}. Puedes guardarlo como una nueva copia.`)
};

const zh_cn2_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此项目目前已被${i?.user}锁定。您可以另存为新副本。`)
};

const ja_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このプロジェクトは現在${i?.user}によってロックされています。代わりに新しいコピーとして保存できます。`)
};

const hi_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`यह प्रोजेक्ट वर्तमान में ${i?.user} द्वारा लॉक किया गया है। आप इसके बजाय एक नई कॉपी सहेज सकते हैं।`)
};

const pt_pt2_project_locked_by = /** @type {(inputs: Project_Locked_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este projeto está atualmente bloqueado por ${i?.user}. Você pode salvá-lo como uma nova cópia.`)
};

/**
* | output |
* | --- |
* | "This project is currently locked by {user}. You can save as a new copy instead." |
*
* @param {Project_Locked_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_locked_by = /** @type {((inputs: Project_Locked_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Locked_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_locked_by(inputs)
	if (locale === "de") return de_project_locked_by(inputs)
	if (locale === "it") return it_project_locked_by(inputs)
	if (locale === "ru") return ru_project_locked_by(inputs)
	if (locale === "es") return es_project_locked_by(inputs)
	if (locale === "zh-CN") return zh_cn2_project_locked_by(inputs)
	if (locale === "ja") return ja_project_locked_by(inputs)
	if (locale === "hi") return hi_project_locked_by(inputs)
	if (locale === "pt-PT") return pt_pt2_project_locked_by(inputs)
	return en_project_locked_by(inputs)
});